<template>
  <div class="wrapper msc-legal-page">
    <header class="msc-legal-hero">
      <div
        class="msc-legal-hero__media"
        aria-hidden="true"
        style="background-image: url('/img/back-to-school-start-MACVKugZ8WQ.jpg')"
      ></div>
      <div class="msc-legal-hero__scrim" aria-hidden="true"></div>
      <div class="msc-legal-hero__content">
        <p class="msc-legal-hero__eyebrow">Privacy</p>
        <h1 class="msc-legal-hero__title">Privacy Policy of Newcare International, LLC</h1>
      </div>
    </header>

    <section class="msc-legal-body">
      <div class="container msc-legal-body__container">
        <p class="msc-legal-meta">Effective as of: July 24, 2026</p>

        <p class="msc-legal-intro">
          Newcare International, LLC (“Newcare,” “we,” “us,” or “our”) operates mySchool.cafe and related
          services (the “Service”). This page explains how we handle personal information when you use
          the Service. By using the Service, you agree to this Privacy Policy.
        </p>

        <section class="msc-legal-section">
          <h2>Our approach</h2>
          <p>
            We collect and use personal information only as needed to provide school meal ordering and
            related account features for your household and your school. We do not sell personal
            information. We do not use it for marketing lists, advertising networks, or unsolicited
            outreach.
          </p>
          <p class="msc-legal-plain">
            <strong>In plain terms</strong>
            Your information is here so lunch ordering works for your family and school — not so we can
            contact you for other purposes.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Information we collect</h2>
          <p>
            Depending on how you use the Service, we may collect information such as your name, email
            address, password (stored in protected form), household or student details needed for meal
            ordering, school association, order history, and account preferences. Your school may also
            provide limited information so your account can be connected to the correct cafeteria program.
          </p>
          <p class="msc-legal-plain">
            <strong>In plain terms</strong>
            We ask for the basics needed to create your account and place meal orders — nothing more than
            the Service requires.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>How we use information</h2>
          <p>We use personal information to:</p>
          <ul>
            <li>Operate and maintain your account and the meal-ordering Service</li>
            <li>Show menus, accept orders, and display order history and balances where applicable</li>
            <li>Allow your school (or its authorized staff) to fulfill and manage cafeteria orders</li>
            <li>Send service-related messages you request or that are required for the Service to work
              (for example, registration confirmation or password reset)</li>
            <li>Protect the Service, prevent misuse, and meet legal obligations</li>
          </ul>
          <p>
            We do not use your personal information to market unrelated products or services, and we do
            not contact you for promotional purposes.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Log data</h2>
          <p>
            When you use the Service, our systems may record standard technical information such as IP
            address, browser type, pages visited, and timestamps. We use this for security, troubleshooting,
            and keeping the Service reliable — not for advertising.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Cookies</h2>
          <p>
            We use cookies and similar technologies as needed for sign-in, session security, and basic
            site operation. If you disable cookies, some parts of the Service may not work.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Service providers and your school</h2>
          <p>
            We may use trusted third parties to host or support the Service (for example, hosting or
            email delivery for account messages). Those providers may process information only as needed
            to perform work for us, and are expected not to use it for their own purposes.
          </p>
          <p>
            Because mySchool.cafe is offered for schools, authorized school staff may access information
            related to students, orders, and accounts as needed to run their meal program.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Security</h2>
          <p>
            We use commercially reasonable safeguards to protect personal information. No method of
            transmission or storage is completely secure, so we cannot guarantee absolute security.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Links to other sites</h2>
          <p>
            The Service may link to sites we do not operate. Their privacy practices are their own; we
            encourage you to review their policies.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Children</h2>
          <p>
            mySchool.cafe is used by parents and guardians in connection with school meal programs.
            Student-related information is handled only to support those programs under the school’s
            relationship with us.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Changes to this policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes take effect when posted on this
            page. Please review it periodically.
          </p>
        </section>

        <section class="msc-legal-section">
          <h2>Contact us</h2>
          <p>
            Questions about this Privacy Policy may be sent to
            <a href="mailto:support@newcare.international">support@newcare.international</a>
            or visit
            <a href="https://www.newcare.international" target="_blank" rel="noopener noreferrer">
              newcare.international
            </a>.
          </p>
          <p>
            Related terms:
            <router-link to="/license">License &amp; Terms of Use</router-link>.
          </p>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'privacy-policy',
    bodyClass: 'msc-legal-page',
  };
</script>
